<template>
  <span>
    <v-tooltip bottom open-delay="500">
      <button
        slot="activator"
        type="button"
        class="tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-md tw-text-neutral-500 hover:tw-text-error-400 hover:tw-bg-neutral-50 tw-transition-colors"
        @click="dialog = true"
      >
        <v-icon small>person_off</v-icon>
      </button>
      <span>Revoke Access</span>
    </v-tooltip>

    <ui-modal v-if="dialog" @close="dialog = false" modal-title="Revoke Access" custom-class="tw-max-w-lg tw-w-full">
      <div class="tw-flex tw-flex-col tw-gap-6 tw-mt-4">
        <p class="tw-text-sm tw-text-neutral-600">
          Please confirm you'd like to revoke
          <span class="tw-font-medium tw-text-neutral-700">{{ user.name || user.email }}</span
          >'s access from the current organization.
        </p>

        <div class="tw-flex tw-justify-end tw-gap-3 tw-pt-4 tw-border-t tw-border-gray-200">
          <ui-button color="secondary" @click.native="dialog = false">Cancel</ui-button>
          <ui-button color="error" :loading="loading" @click.native="revoke">Revoke</ui-button>
        </div>
      </div>
    </ui-modal>
  </span>
</template>

<script>
import gql from 'graphql-tag';

import UiButton from '../ui/UiButton.vue';
import UiModal from '../ui/UiModal.vue';

export default {
  props: ['user'],
  components: {
    UiButton,
    UiModal,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  methods: {
    async revoke() {
      this.loading = true;

      const vars = {
        orgId: this.$store.state.currentOrg.id,
        userId: this.user.id,
      };

      const resp = await this.$apollo.mutate({
        mutation: gql`
          mutation ($orgId: ID!, $userId: ID!) {
            removeOrgUser(orgId: $orgId, userId: $userId) {
              success
              errors
            }
          }
        `,
        variables: vars,
      });

      this.loading = false;
      this.dialog = false;

      if (resp.errors) {
        this.showErrorSnackbar('Problem revoking user: ' + resp.errors.join('<br />'));
      }

      if (resp.data && resp.data.removeOrgUser) {
        this.showSuccessSnackbar('User successfully revoked!');
        this.$emit('completed');
      }
    },
  },
};
</script>
